import { useCallback } from 'react';

import { LessonStatus, LessonType } from '@sayyesschool/common/entities/lesson';
import datetime from '@sayyesschool/common/libs/datetime';
import UserSelect from '@sayyesschool/frontend/components/user-select';
import { lessonLocationsOptions, lessonStatusOptions, lessonTypeOptions } from '@sayyesschool/frontend/features/lessons';
import { useTeachers } from '@sayyesschool/frontend/features/teachers';
import { useFormData } from '@sayyesschool/frontend/hooks/form';
import { Checkbox, Form } from '@sayyesschool/frontend/ui-components';

const getFormData = ({
    status = LessonStatus.Scheduled,
    duration = 50,
    date = new Date(),
    trial = false,
    free = false,
    note = '',
    teacherId,
    learnerId,
    location,
    type = LessonType.Online
}) => ({
    status,
    duration,
    date: datetime(date).format('YYYY-MM-DDTHH:mm'),
    trial,
    free,
    note,
    teacherId,
    learnerId,
    location,
    type
});

export default function LessonForm({ lesson = {}, onSubmit, ...props }) {
    const [teachers] = useTeachers();

    const { data, handleChange } = useFormData(getFormData(lesson));

    const handleSubmit = useCallback(() => {
        if (data.type === LessonType.Online && data.location) {
            data.location = '';
        }

        onSubmit({ ...data, date: datetime(data.date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]') });
    }, [data, onSubmit]);

    return (
        <Form
            className="LessonForm"
            onSubmit={handleSubmit}
            {...props}
        >
            <Form.Select
                label="Статус"
                name="status"
                value={data.status}
                options={lessonStatusOptions}
                required
                onChange={handleChange}
            />

            <Form.Input
                label="Дата и время"
                type="datetime-local"
                name="date"
                value={data.date}
                onChange={handleChange}
            />

            <Form.Input
                label="Продолжительность, мин."
                type="number"
                name="duration"
                step="5"
                value={data.duration}
                onChange={handleChange}
            />

            <UserSelect
                label="Преподаватель"
                name="teacherId"
                value={data.teacherId}
                options={teachers?.map(teacher => ({
                    key: teacher.id,
                    value: teacher.id,
                    label: teacher.fullname
                }))}
                clearOnBlur
                required
                onChange={handleChange}
            />

            <Form.Select
                label="Формат"
                name="type"
                value={data.type}
                options={lessonTypeOptions}
                onChange={handleChange}
            />

            {data.type === LessonType.Offline && (
                <Form.Select
                    label="Локация"
                    name="location"
                    value={data.location}
                    options={lessonLocationsOptions}
                    required
                    onChange={handleChange}
                />
            )}

            <Checkbox
                label="Пробное"
                name="trial"
                checked={data.trial}
                onChange={handleChange}
            />

            <Checkbox
                label="Бесплатное"
                name="free"
                checked={data.free}
                onChange={handleChange}
            />

            <Form.Input
                label="Примечание"
                name="note"
                value={data.note}
                onChange={handleChange}
            />
        </Form>
    );
}